"use client";

import { content } from "../../data/siteData";
import { localePath } from "../../lib/seo";

const linkClass =
  "font-poppins font-light text-gray-400 hover:text-white transition-colors text-xs md:text-sm focus:outline-none focus:ring-2 focus:ring-white rounded";

// homeHref is "" on the home page (plain #anchors) and "/" or "/de" elsewhere.
const Footer = ({ locale, homeHref = "" }) => {
  const t = content[locale].footer;

  const handleScrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <footer className="w-full bg-[#333333] py-8 md:py-12 px-6 md:px-12">
      <div className="max-w-7xl mx-auto flex flex-col md:flex-row justify-between items-center gap-6 md:gap-8">
        <div className="flex flex-col items-center md:items-start gap-1 md:gap-2">
          <p className="font-poppins font-light text-white text-base md:text-lg">
            Alexandre Rodrigues Fernandes
          </p>
          <p className="font-poppins font-light text-gray-400 text-xs md:text-sm">
            {t.role}
          </p>
        </div>

        <div className="flex flex-col items-center gap-3 md:gap-4">
          <nav className="flex gap-4 md:gap-6" aria-label={t.navLabel}>
            <a href={`${homeHref}#about-me`} className={linkClass}>
              {t.about}
            </a>
            <a href={`${homeHref}#projects`} className={linkClass}>
              {t.projects}
            </a>
            <a href={`${homeHref}#contact`} className={linkClass}>
              {t.contact}
            </a>
          </nav>
          <p className="font-poppins font-light text-gray-400 text-[10px] md:text-xs">
            &copy; 2026 Alexandre Rodrigues Fernandes. {t.rights} &middot;{" "}
            <a
              href={localePath(locale, "/impressum")}
              className="hover:text-white underline underline-offset-2 transition-colors"
            >
              {t.legal}
            </a>{" "}
            &middot;{" "}
            <a
              href={localePath(locale, "/datenschutz")}
              className="hover:text-white underline underline-offset-2 transition-colors"
            >
              {t.privacy}
            </a>
          </p>
        </div>

        <button
          onClick={handleScrollToTop}
          className="font-poppins font-light text-gray-400 hover:text-white transition-colors text-xs md:text-sm focus:outline-none focus:ring-2 focus:ring-white rounded px-2 py-1"
          aria-label={t.backToTopLabel}
        >
          &uarr; {t.backToTop}
        </button>
      </div>
    </footer>
  );
};

export default Footer;
